/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_About_HintInputs */

const en_us2_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, birth, sex and height`)
};

const pt_br2_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome, nascimento, sexo e altura`)
};

const es_419_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre, nacimiento, sexo y estatura`)
};

const pt_pt2_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome, nascimento, sexo e altura`)
};

const fr_fr2_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom, naissance, sexe et taille`)
};

const de_de2_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, Geburtsdatum, Geschlecht und Größe`)
};

const it_it2_profile_page_about_hint = /** @type {(inputs: Profile_Page_About_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome, nascita, sesso e altezza`)
};

/**
* | output |
* | --- |
* | "Name, birth, sex and height" |
*
* @param {Profile_Page_About_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_about_hint = /** @type {((inputs?: Profile_Page_About_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_About_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_about_hint(inputs)
	if (locale === "es-419") return es_419_profile_page_about_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_about_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_about_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_page_about_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_page_about_hint(inputs)
	return en_us2_profile_page_about_hint(inputs)
});
export { profile_page_about_hint as "profile.page_about_hint" }